import Vue from 'vue'
import VueRouter from 'vue-router'
import request from '@/utils/request'
import My from '@/views/my'

Vue.use(VueRouter)

/* Layout */
import Layout from '@/views/layout'

// 公共路由
export const constantRoutes = [
  {
    path: "/redirect/:path(.*)",
    component: () => import("@/views/redirect/index.vue"),
  },
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  {
    path: '/404',
    component: () => import('@/views/error/404')
  },

  {
    path: '',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/home/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      },
      {
        path: 'textbook',
        component: () => import('@/views/textbook/index'),
        name: 'Textbook',
        meta: { title: '教材', icon: 'dashboard', affix: true }
      },
      {
        path: 'textbook-search',
        component: () => import('@/views/textbook/index'),
        name: 'TextbookSearch',
        meta: { title: '检索结果', icon: 'dashboard', affix: true }
      },
      {
        path: 'booklist',
        component: () => import('@/views/booklist/index'),
        name: 'Booklist',
        meta: { title: '书单', icon: 'dashboard', affix: true }
      },
      {
        path: 'booksearch',
        component: () => import('@/views/booklist/search'),
        name: 'Booksearch',
        meta: { title: '书单检索结果', icon: 'dashboard', affix: true }
      },
      {
        path: 'booklistdetail',
        component: () => import('@/views/booklist/detail'),
        name: 'Booklistdetail',
        meta: { title: '书单详情', icon: 'dashboard', affix: true }
      },
      {
        path: 'search',
        component: () => import('@/views/search/index'),
        name: 'Search',
        meta: { title: '搜索', icon: 'dashboard', affix: true }
      },
      {
        path: 'search-result',
        component: () => import('@/views/search/searchResult'),
        name: 'SearchResult',
        meta: { title: '条件搜索', icon: 'dashboard', affix: true }
      },
      {
        path: 'search-result-detail',
        component: () => import('@/views/search/searchResultDetail'),
        name: 'SearchResultDetail',
        meta: { title: '搜索详情', icon: 'dashboard', affix: true }
      },
      {
        path: 'book-detail',
        component: () => import('@/views/search/bookDetail'),
        name: 'bookDetail',
        meta: { title: '图书详情', icon: 'dashboard', affix: true, isFullScreen: true }
      },
      // {
      //   path: 'book-detail-infomation',
      //   component: () => import('@/views/search/bookDetailedInformation'),
      //   name: 'bookDetailedInformation',
      //   meta: { title: '书籍详情', icon: 'dashboard', affix: true }
      // },
      {
        path: 'blog-detail',
        component: () => import('@/views/blog/index'),
        name: 'blogDetail',
        meta: { title: '资讯详情', icon: 'dashboard', affix: true }
      },
      {
        path: 'faq',
        component: () => import('@/views/faq/index'),
        name: 'faq',
        meta: { title: '常见问题', icon: 'dashboard', affix: true }
      },
      {
        path: 'about',
        component: () => import('@/views/about/index'),
        name: 'about',
        meta: { title: '关于我们', icon: 'dashboard', affix: true }
      },
      {
        path: 'researchers',
        component: () => import('@/views/about/index'),
        name: 'researchers',
        meta: { title: '研究人员', icon: 'dashboard', affix: true }
      },
      {
        path: 'librarian',
        component: () => import('@/views/about/index'),
        name: 'librarian',
        meta: { title: '图书管理员', icon: 'dashboard', affix: true }
      },
      {
        path: 'publisher',
        component: () => import('@/views/about/index'),
        name: 'publisher',
        meta: { title: '出版社', icon: 'dashboard', affix: true }
      },
      {
        path: 'more-blog',
        component: () => import('@/views/blog/more-blog'),
        name: 'more-blog',
        meta: { title: '资讯', icon: 'dashboard', affix: true }
      },
      {
        path: "/message",
        name: "Message",
        component: () => import("@/views/message"),
        meta: { shieldBottom: true, title: "消息" },
      },
      {
        path: "textbookReport",
        name: "TextbookReport",
        component: () => import("@/views/my/studyReport/textbookReport"),
        hidden: true,
        meta: {
          title: "教材报告",
          shieldBottom: true,
        },
      },
      {
        path: "teachingReport",
        name: "TeachingReport",
        component: () => import("@/views/my/teachingSpace/teachingReport"),
        meta: { shieldBottom: true, title: "学习报告" },
      },
      {
        path: "/my",
        name: "my",
        component: My,
        meta: {
          title: "我的",
          shieldBottom: true,
        },
        children: [
          {
            path: "questionBank",
            name: "QuestionBank",
            component: () => import("@/views/my/questionBank"),
            meta: { shieldBottom: true }
          },
          {
            path: "/person",
            name: "Person",
            component: () => import("@/views/my/person"),
            meta: { title: "我的账号", shieldBottom: true },
          },
          {
            path: "/academy",
            name: "Academy",
            component: () => import("@/views/my/academy"),
            meta: { title: "院校信息", shieldBottom: true },
          },
          {
            path: "/teachCourse",
            name: "TeachCourse",
            component: () => import("@/views/my/teachCourse"),
            meta: { title: "我教的课", shieldBottom: true },
          },
          {
            path: "/studyCourse",
            name: "StudyCourse",
            component: () => import("@/views/my/studyCourse"),
            meta: { title: "我学的课", shieldBottom: true },
          },
          {
            path: "/teachingSpace",
            name: "TeachingSpace",
            component: () => import("@/views/my/teachingSpace"),
            meta: { title: "教学空间", shieldBottom: true },
          },
          {
            path: "/admissionDetails",
            name: "AdmissionDetails",
            component: () =>
              import("@/views/my/teachingSpace/admissionDetails"),
            meta: { title: "入班学生详情", shieldBottom: true },
          },
          {
            path: "/authDetails",
            name: "AuthDetails",
            component: () => import("@/views/my/academy/components/auth"),
            meta: { title: "授权设置详情", shieldBottom: true },
          },
          {
            path: "/provideBook",
            name: "ProvideBook",
            component: () => import("@/views/my/provideBook"),
            meta: { title: "教材发放", shieldBottom: true },
          },
          {
            path: "/sampleBook",
            name: "SampleBook",
            component: () => import("@/views/my/sampleBook"),
            meta: { title: "试用申请", shieldBottom: true },
          },
          {
            path: "/studyReport",
            name: "StudyReport",
            component: () => import("@/views/my/studyReport"),
            meta: { title: "阅读报告", shieldBottom: true },
          },
          {
            path: "/joinClass",
            name: "JoinClass",
            component: () => import("@/views/my/joinClass"),
            meta: { title: "我加入的班级", shieldBottom: true },
          },
          {
            path: "/collect",
            name: "Collect",
            component: () => import("@/views/my/collect"),
            meta: { title: "我的收藏", shieldBottom: true },
          },
          {
            path: "/record",
            name: "Record",
            component: () => import("@/views/my/record"),
            meta: { title: "购买记录", shieldBottom: true },
          },
          {
            path: "/help",
            name: "Help",
            component: () => import("@/views/my/help"),
            meta: { title: "使用帮助", shieldBottom: true },
          },
          {
            path: "/feedback",
            name: "Feedback",
            component: () => import("@/views/my/feedback"),
            meta: { title: "我的反馈", shieldBottom: true },
          },
          {
            path: "/helpDetail",
            name: "HelpDetail",
            component: () => import("@/views/my/help/helpDetail"),
            meta: { title: "帮助详情", shieldBottom: true },
          },
          {
            path: "/teachingActivity",
            name: "TeachingActivity",
            component: () => import("@/views/my/teachingActivity"),
            meta: { title: "教学活动", shieldBottom: true },
          },
        ],
      },
      // {
      //   path: 'download',
      //   component: () => import('@/views/download/index'),
      //   name: 'download',
      //   meta: { title: '客户端下载', icon: '', affix: true }
      // },
      {
        path: "list",
        name: "List",
        component: () => import("@/views/bookLists"),
        hidden: true,
        meta: { shieldBottom: true },
      },
    ]
  },
  {
    path: '/bookPreview',
    component: () => import('@/views/bookPreview/index'),
    name: 'bookPreview',
    meta: { title: '预览', icon: '', affix: true }
  },
  {
    path: '/pagePractice',
    component: () => import('@/views/pagePractice/index'),
    name: 'pagePractice',
    meta: { title: '测验', icon: '', affix: true }
  },
  {
    path: '*',
    component: () => import('@/views/error/404')
  }
]

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err)
}

const route = new VueRouter({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  // base: '/pc/',
  routes: constantRoutes
})
console.log(process.env.NODE_ENV)

// route.beforeEach((to, from, next) => {
//   next()
// })
route.afterEach((to) => {
  request({
    // 数据埋点
    url: '/api/router',
    method: 'post',
    data: { path: window.location.href }
  })
})
export default route
